import { render, staticRenderFns } from "./CommonCommunity.vue?vue&type=template&id=4c926b8a&scoped=true&"
import script from "./CommonCommunity.vue?vue&type=script&lang=ts&"
export * from "./CommonCommunity.vue?vue&type=script&lang=ts&"
import style0 from "./CommonCommunity.vue?vue&type=style&index=0&id=4c926b8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c926b8a",
  null
  
)

export default component.exports